exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".heading-NdMmH{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;margin-bottom:20px;text-align:left}.line-IV2MH{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;height:1px;background-color:#fff;opacity:.3}.line-IV2MH:first-child{margin-right:20px}.line-IV2MH:last-child{margin-left:20px}.uppercase-3c7J1{text-transform:uppercase}.noMargin-1gV6a{margin:0}.center-1BoUG{text-align:center}.center-1BoUG .h1-3G3vE,.center-1BoUG .h2-K02Y9,.center-1BoUG .h3-38cuq,.center-1BoUG .h4-9A8xj,.center-1BoUG .h5-v4xZc,.center-1BoUG .h6-2SZbK{margin:0 auto}.h1-3G3vE,.h2-K02Y9,.h3-38cuq,.h4-9A8xj,.h5-v4xZc,.h6-2SZbK{-webkit-box-flex:0;-ms-flex-positive:0;flex-grow:0;margin:0;padding:0;text-align:inherit;position:relative}h1{font-weight:700;font-size:1.875rem;line-height:1.33}h2{font-weight:600;font-size:1.5rem;line-height:1.43}h3{font-weight:600;font-size:1.25rem;line-height:1.43}h4{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin-bottom:40px;font-weight:400;font-size:1rem;line-height:1.33}h5{font-weight:400;font-size:1.125rem;line-height:1.33}h6{font-weight:400;font-size:1rem;line-height:1.33}", ""]);

// exports
exports.locals = {
	"heading": "heading-NdMmH",
	"line": "line-IV2MH",
	"uppercase": "uppercase-3c7J1",
	"noMargin": "noMargin-1gV6a",
	"center": "center-1BoUG",
	"h1": "h1-3G3vE",
	"h2": "h2-K02Y9",
	"h3": "h3-38cuq",
	"h4": "h4-9A8xj",
	"h5": "h5-v4xZc",
	"h6": "h6-2SZbK"
};